import { BaseModel } from 'sjs-base-model';

export class ProductModel extends BaseModel {
  public productId: string = '';
  public name: string = '';
  public description: string = '';
  public service: string = '';
  public eexProductId: string = '';
  public createdDate: string = '';
  public updatedDate: string = '';
  public createdBy: string = '';
  public updatedBy: string = '';

  constructor(data: Partial<ProductModel>) {
    super();
    this.update({
      productId: data.productId ?? 0,
      name: data.name ?? '',
      description: data.description ?? '',
      service: data.service ?? '',
      eexProductId: data.eexProductId ?? '',
      createdDate: data.createdDate ?? '',
      updatedDate: data.updatedDate ?? '',
      createdBy:   data.createdBy ?? '',
      updatedBy:   data.updatedBy ?? '',
    });
  }
}

export class ProductFeatureModel extends BaseModel {

  [key: string]: any;

  constructor(data: Partial<ProductFeatureModel>) {
    super();
    Object.assign(this, data);
  }
}

export class ProductDetailsModel {
  productId: string;
  name: string;
  description: string;
  eexProductId: string;
  productFeatures: ProductFeatureModel[];

  constructor(data: Partial<ProductDetailsModel>) {
    this.productFeatures = (data.productFeatures || []).map((item: any) => new ProductFeatureModel(item));
    this.productId = data.productId ?? '';
    this.name = data.name ?? '';
    this.description = data.description ?? '';
    this.eexProductId = data.eexProductId ?? '';
  }

}